// extracted by mini-css-extract-plugin
export default {"invalid":"LoginModal_invalid__8fAjf","errorText":"LoginModal_errorText__GYne+"};